var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6595 13.8137L6.78682 10.0538C6.59992 9.8723 6.31215 9.867 6.11917 10.0414L1.32719 14.3717C1.00333 14.6643 0.5 14.4241 0.5 13.9769V1.0221C0.5 0.7338 0.723858 0.5 1 0.5H11C11.2761 0.5 11.5 0.7338 11.5 1.0221V13.4314C11.5 13.8874 10.9794 14.1242 10.6595 13.8137Z",
    fill: "#F8F8F8",
    stroke: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/Bookmark.091fe5de4e2a1ef052aafe1a47301d48.svg";
export { ForwardRef as ReactComponent };